document.addEventListener("DOMContentLoaded", function () {

  const VISITS_KEY = "retention_pago_flex_visits";
  const LAST_SHOWN_KEY = "retention_pago_flex_last_shown";

  const COOLDOWN_HOURS = 4;
  const COOLDOWN_MS = COOLDOWN_HOURS * 60 * 60 * 1000;

  const overlay = document.querySelector(".retention_pago_flex_overlay");
  const closeBtn = document.querySelector(".retention_pago_flex_close");

  if (!overlay) return;

  // Contador de visitas
  let visits = parseInt(localStorage.getItem(VISITS_KEY) || "0", 10);
  visits++;
  localStorage.setItem(VISITS_KEY, visits);

  // Timestamp última vez mostrado
  const lastShown = parseInt(
    localStorage.getItem(LAST_SHOWN_KEY) || "0",
    10
  );

  const now = Date.now();
  const cooldownExpired = (now - lastShown) > COOLDOWN_MS;

  // Mostrar desde la segunda visita
  if (visits >= 2 && cooldownExpired) {
    overlay.style.display = "flex";
    localStorage.setItem(LAST_SHOWN_KEY, now);
  }

  // Cerrar
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      overlay.style.display = "none";
    });
  }

});